// src/components/Premium/PremiumBannerLocked.tsx
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Crown, Lock, ArrowRight } from 'lucide-react';

interface Props {
  onGoInvestigations?: () => void; // 👈 nuevo
}

const PremiumBannerLocked: React.FC<Props> = ({ onGoInvestigations }) => {
  const { t } = useTranslation();

  return (
    <div className="relative overflow-hidden rounded-3xl bg-gradient-to-r from-slate-800 via-slate-700 to-slate-600 p-8 text-white shadow-lg">
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex items-center gap-3">
          <span className="inline-flex h-12 w-12 items-center justify-center rounded-2xl bg-white/15">
            <Crown className="h-6 w-6" />
          </span>
          <div>
            <h1 className="text-2xl font-extrabold">{t('premium.title_temp')}</h1>
            <p className="text-white/80">{t('premium.subtitle_temp')}</p>
          </div>
        </div>

        <button
          type="button"
          onClick={onGoInvestigations}
          className="inline-flex items-center gap-2 rounded-xl bg-gradient-to-r from-rose-500 to-pink-500 px-4 py-2.5 font-semibold text-white shadow hover:opacity-90"
        >
          <Lock className="h-4 w-4" />
          {t('premium.cta_go_investigations')}
          <ArrowRight className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
};

export default PremiumBannerLocked;
